import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import Home from "../component/home";
import DownloadAdobe from "../component/AdobeContent";
import DownloadBook from "../component/DownloadPDF";
import Expired from "../component/common/expired/expired";
import { config } from "../config/api";
import { iwmsGet } from "../httpClient/index"


// const secretKey = "integra@ecomp";

// -----------------------------------------------------
// Helper: Decrypt File ID
// -----------------------------------------------------
// const decryptFileId = (encryptedFileId: string | undefined): string | null => {
//   if (!encryptedFileId) return null;

//   try {
//     const base64 = encryptedFileId.replace(/-/g, "+").replace(/_/g, "/");
//     const encryptedText = atob(base64);

//     const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
//     const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

//     return decryptedText || null;
//   } catch (err) {
//     console.error("Error decrypting file id:", err);
//     return null;
//   }
// };

// -----------------------------------------------------
// Component
// -----------------------------------------------------
const ProtectedPage = () => {
  const { encryfileid } = useParams();
  //const fileid = decryptFileId(encryfileid);

  const [activeTab, setActiveTab] = useState<"home" | "adobe" | "book">("home");
  const [tabDisable, setTabDisable] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [isExpired, setIsExpired] = useState(false);

  const [loading, setLoading] = useState(true); // <-- LOADER STATE
  const [isError, setIsError] = useState(false);

  // -----------------------------------------------------
  // Fetch Data
  // -----------------------------------------------------
  const getData = useCallback(async () => {
    if (!encryfileid) {
      setLoading(false);
      return;
    }

    try {
      const endpoint = `${config.server.baseUrl}${config.server.uri.getecompinfo}${encryfileid}`;
      const { data: responseData } = await iwmsGet(endpoint);
      if (!responseData || responseData.isExpired) {
        setIsExpired(true);
      } else {
        setData(responseData);
      }
    } catch (err) {
      setIsError(true);
    } finally {
      setLoading(false); // <-- STOP LOADER AFTER API COMPLETES
    }
  }, [encryfileid]);

  useEffect(() => {
    getData();
  }, [getData]);

  // -----------------------------------------------------
  // Tab Handling
  // -----------------------------------------------------
  const handleTimelineClick = (tab: "home" | "adobe" | "book") => {
    if (tabDisable) setActiveTab(tab);
  };

  const progressWidth =
    activeTab === "home" ? "0%" : activeTab === "adobe" ? "33.33%" : "67%";

  // -----------------------------------------------------
  // Loader UI
  // -----------------------------------------------------
  if (loading) {
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="loader-wrapper">
        <div className="error-icon">⚠️</div>
        <p className="error-text">Something went wrong. Please refresh and try again.</p>
      </div>
    );
  }



  // -----------------------------------------------------
  // UI
  // -----------------------------------------------------
  return (
    <>
      <div className="protected-page-head">
        <div className="heading-container">
          <p className="heading-text">E-Comp</p>
        </div>
      </div>

      <div className="main-container">
        {isExpired ? (
          <Expired />
        ) : (
          <div className="content-with-timeline">
            {/* Timeline */}
            <div className="vertical-timeline-container">
              <div className="vertical-timeline">
                <div className="vertical-timeline-line" />

                <div
                  className="vertical-timeline-progress"
                  style={{ width: progressWidth }}
                />

                {/* Step 1 */}
                <div
                  className={`vertical-timeline-step ${activeTab === "home" ? "active" : ""
                    }`}
                  onClick={() => handleTimelineClick("home")}
                >
                  <div className="vertical-timeline-point">
                    <span>1</span>
                  </div>
                  <div className="vertical-timeline-label">Home</div>
                </div>

                {/* Step 2 */}
                <div
                  className={`vertical-timeline-step ${activeTab === "adobe" ? "active" : ""
                    }`}
                  onClick={() => handleTimelineClick("adobe")}
                >
                  <div className="vertical-timeline-point">
                    <span>2</span>
                  </div>
                  <div className="vertical-timeline-label">
                    Download Adobe Reader
                  </div>
                </div>

                {/* Step 3 */}
                <div
                  className={`vertical-timeline-step ${activeTab === "book" ? "active" : ""
                    }`}
                  onClick={() => handleTimelineClick("book")}
                >
                  <div className="vertical-timeline-point">
                    <span>3</span>
                  </div>
                  <div className="vertical-timeline-label">
                    Download the Book
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="tab-content-container">
              <div className="tab-content">
                {activeTab === "home" && (
                  <Home
                    setActiveTab={setActiveTab}
                    setCallbackCheck={setTabDisable}
                    data={data}
                  />
                )}

                {activeTab === "adobe" && (
                  <DownloadAdobe setActiveTab={setActiveTab} />
                )}

                {activeTab === "book" && (
                  <DownloadBook setActiveTab={setActiveTab} data={data} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProtectedPage;
